import React from 'react';
export function PauseIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.694 17c0 1.105.76 2 1.695 2 .936 0 1.694-.895 1.694-2V7c0-1.105-.758-2-1.694-2-.936 0-1.694.895-1.694 2v10zm-6.778 0c0 1.105.76 2 1.695 2 .936 0 1.694-.895 1.694-2V7c0-1.105-.758-2-1.694-2-.936 0-1.695.895-1.695 2v10z"
  }));
}